import { FormBaseType } from "@green0meter/api-client";

export const VSME_CONFIG = {
  formBaseType: FormBaseType.VSME,
  welcomeBanner: {
    titleKey: "vsmehub.welcome",
    textKey: "vsmehub.welcomeText",
    color: "blue",
    icon: "accountant",
  },
  collectData: {
    titleKey: "vsmeCollectionDataTitle",
    descriptionKey: "vsmeCollectionDataDescription",
    color: "violet",
    icon: "data-gathering",
    buttonTextKey: "vsmeCollectionDataButtonStart",
    noFormsTextKey: "collectData.noFormsCreated",
  },
  reports: {
    titleKey: "vsme.hub.reports.title",
    type: "vsme-reports",
    noReportsTextKey: "vsme.hub.reports.noReports",
    fillFormTextKey: "vsme.hub.reports.fillForm",
  },
  overview: {
    titleKey: "vsme.hub.overview.title",
    dashboardPath: "/vsme/dashboard",
    viewDashboardTextKey: "common.viewDashboard",
    reportPageId: "",
  },
};
